import { Component } from '@angular/core';
import { Router } from '@angular/router';
import { CapitalContainer } from '@commons/capital-container/capital-container';
import { CapitalButton } from '@commons/capital-button/capital-button';
import { DevToolsService } from '@commons/services/dev-tools.service';

@Component({
  selector: 'app-welcome',
  imports: [CapitalContainer, CapitalButton],
  templateUrl: './welcome.html',
  styleUrl: './welcome.scss',
})
export class Welcome {
  constructor(private readonly devToolsService: DevToolsService, private readonly router: Router){}

  // Getters para acceder a los signals del servicio
  get showDevTools() {
    return this.devToolsService.devToolsVisible();
  }

  get isConsoleLogEnabled() {
    return this.devToolsService.consoleLogEnabled();
  }

  goLogin() {
    this.router.navigate(['/security-key-login'])
  }

  goAgile() {
    this.router.navigate(['/agile-login'])
  }

  toggleConsoleLog() {
    this.devToolsService.toggleConsoleLog();
  }

}
